module.exports = __webpack_public_path__ + "img/772.748be307.png";